! function() {
    "use strict";
    var t, e = {
            4528: function(t, e, n) {
                var i = n(970),
                    r = n.n(i),
                    o = n(4105);
                document.addEventListener("DOMContentLoaded", (function() {
                    document.querySelectorAll(".icon").forEach((t => {
                        t.classList.add("loaded")
                    })), document.querySelectorAll('a[target="_blank"]').forEach((t => {
                        t.innerHTML = t.innerHTML + '<span class="visually-hidden"> ' + accessibilityNoticeNewTab + "</span>"
                    }))
                })), void 0 === window.Shopify && (window.Shopify = {}), Shopify.bind = function(t, e) {
                    return function() {
                        return t.apply(e, arguments)
                    }
                }, Shopify.setSelectorByValue = function(t, e) {
                    for (var n = 0, i = t.options.length; n < i; n++) {
                        var r = t.options[n];
                        if (e == r.value || e == r.innerHTML) return t.selectedIndex = n, n
                    }
                }, Shopify.addListener = function(t, e, n) {
                    t.addEventListener ? t.addEventListener(e, n, !1) : t.attachEvent("on" + e, n)
                }, Shopify.postLink = function(t, e) {
                    var n = (e = e || {}).method || "post",
                        i = e.parameters || {},
                        r = document.createElement("form");
                    for (var o in r.setAttribute("method", n), r.setAttribute("action", t), i) {
                        var a = document.createElement("input");
                        a.setAttribute("type", "hidden"), a.setAttribute("name", o), a.setAttribute("value", i[o]), r.appendChild(a)
                    }
                    document.body.appendChild(r), r.submit(), document.body.removeChild(r)
                }, Shopify.CountryProvinceSelector = function(t, e, n) {
                    this.countryEl = document.getElementById(t), this.provinceEl = document.getElementById(e), this.provinceContainer = document.getElementById(n.hideElement || e), Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)), this.initCountry(), this.initProvince()
                }, Shopify.CountryProvinceSelector.prototype = {
                    initCountry: function() {
                        var t = this.countryEl.getAttribute("data-default");
                        Shopify.setSelectorByValue(this.countryEl, t), this.countryHandler()
                    },
                    initProvince: function() {
                        var t = this.provinceEl.getAttribute("data-default");
                        t && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, t)
                    },
                    countryHandler: function(t) {
                        var e = (r = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),
                            n = JSON.parse(e);
                        if (this.clearOptions(this.provinceEl), n && 0 == n.length) this.provinceContainer.style.display = "none";
                        else {
                            for (var i = 0; i < n.length; i++) {
                                var r;
                                (r = document.createElement("option")).value = n[i][0], r.innerHTML = n[i][1], this.provinceEl.appendChild(r)
                            }
                            this.provinceContainer.style.display = ""
                        }
                    },
                    clearOptions: function(t) {
                        for (; t.firstChild;) t.removeChild(t.firstChild)
                    },
                    setOptions: function(t, e) {
                        var n = 0;
                        for (e.length; n < e.length; n++) {
                            var i = document.createElement("option");
                            i.value = e[n], i.innerHTML = e[n], t.appendChild(i)
                        }
                    }
                };
                const a = () => {
                    var t = [].slice.call(document.querySelectorAll("img"));
                    if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
                        let e = new IntersectionObserver((function(t, e) {
                            t.forEach((function(t) {
                                if (t.isIntersecting) {
                                    let n = t.target;
                                    n.classList.contains("loaded") || (n.classList.add("loaded"), e.unobserve(n))
                                }
                            }))
                        }));
                        t.forEach((function(t) {
                            e.observe(t)
                        }))
                    }
                };
                a(), document.querySelectorAll("video").forEach((t => {
                    t.muted = !0;
                    let e = t.play();
                    void 0 !== e && e.then((e => {
                        new IntersectionObserver((e => {
                            e.forEach((e => {
                                e.isIntersecting || t.paused ? t.paused && t.autoplay && t.play() : t.pause()
                            }))
                        }), {
                            threshold: 0
                        }).observe(t)
                    }))
                }));
                const s = function() {
                    [].slice.call(document.querySelectorAll("video")).forEach((t => {
                        const e = t.parentElement.querySelector(".figure--video__poster");
                        e && e.addEventListener("click", (() => {
                            e.classList.add("hidden"), t.play()
                        }))
                    }));
                    var t = [].slice.call(document.querySelectorAll(".figure--video-external"));
                    if ("IntersectionObserver" in window) {
                        var e = new IntersectionObserver((function(t, e) {
                            t.forEach((function(t) {
                                if (t.isIntersecting) "vimeo" == t.target.dataset.type && fetch("http://vimeo.com/api/v2/video/" + t.target.dataset.id + ".json").then((t => {
                                    if (!t.ok) throw new Error(`HTTP error ${t.status}`);
                                    return t.json()
                                })).then((e => {
                                    t.target.querySelector(".figure--video__external-poster-image").src = e[0].thumbnail_large
                                })), t.target.addEventListener("click", (function() {
                                    if (!t.target.querySelector("iframe")) {
                                        let t = this.dataset.type,
                                            e = document.createElement("iframe");
                                        e.setAttribute("frameborder", "0"), e.setAttribute("allowfullscreen", ""), e.setAttribute("allow", "autoplay"), "youtube" == t ? (e.setAttribute("id", "youtube"), e.setAttribute("src", "https://www.youtube.com/embed/" + this.dataset.id + this.dataset.videotags + "rel=0&showinfo=0&autoplay=1")) : e.setAttribute("src", "https://player.vimeo.com/video/" + this.dataset.id + this.dataset.videotags + "rel=0&showinfo=0&autoplay=1"), this.querySelector(".figure--video__poster").classList.add("hidden"), this.appendChild(e)
                                    }
                                }));
                                else if (t.target.querySelector("iframe")) {
                                    let n = t.target.dataset.type,
                                        i = t.target.querySelectorAll("iframe");
                                    if ("youtube" == n) {
                                        var e = {
                                            event: "command",
                                            func: "pauseVideo"
                                        };
                                        i[0].contentWindow.postMessage(JSON.stringify(e), "*")
                                    } else "vimeo" == n && (e = {
                                        method: "pause",
                                        value: "true"
                                    }, i[0].contentWindow.postMessage(JSON.stringify(e), "*"))
                                }
                            }))
                        }));
                        t.forEach((function(t) {
                            e.observe(t)
                        }))
                    }
                };
                s(), window.addEventListener("beforeprint", (() => {
                    const t = document.body.querySelectorAll("details"),
                        e = document.body.querySelectorAll("img");
                    for (let e = 0; e < t.length; e++) t[e].open ? t[e].dataset.open = "1" : t[e].setAttribute("open", "");
                    for (let t = 0; t < e.length; t++) e[t].dataset.open = "1"
                })), window.addEventListener("afterprint", (() => {
                    const t = document.body.querySelectorAll("details");
                    for (let e = 0; e < t.length; e++) t[e].dataset.open ? t[e].dataset.open = "" : t[e].removeAttribute("open")
                })), Shopify.designMode && document.addEventListener("shopify:section:load", (() => {
                    s(), document.querySelectorAll(".icon").forEach((t => {
                        t.classList.add("loaded")
                    })), document.querySelectorAll("noscript.loading-lazy").forEach((t => {
                        r().prepareElement(t), t.classList.add("loaded")
                    })), document.querySelectorAll("img").forEach((t => {
                        t.classList.add("loaded")
                    }))
                }));
                class c extends HTMLElement {
                    constructor() {
                        super(), this.addEventListener("change", this.onVariantChange)
                    }
                    onVariantChange() {
                        this.updateOptions(), this.updateMasterId(), this.currentVariant ? (this.updateMedia(), this.updateURL(), this.renderProductInfo(), this.updateVariantInput(), this.toggleStockStatus(this.currentVariant.available)) : this.setUnavailable()
                     console.log(this.currentVariant)
                    }
                    updateOptions() {
                        this.options = Array.from(this.querySelectorAll("select"), (t => t.value))
                    }
                    updateMasterId() {
                        this.currentVariant = this.getVariantData().find((t => !t.options.map(((t, e) => this.options[e] === t)).includes(!1)))
                    }
                    updateMedia() {
                        if (!this.currentVariant) return;
                        if (!this.currentVariant.featured_media) return;
                        const t = document.querySelector(`.product-converter__gallery#gallery-${this.dataset.section} .swiper-wrapper`);
                        if (this.currentVariant.featured_media) {
                            const e = this.currentVariant.featured_media.id;
                            document.querySelector(`.product-converter__gallery#gallery-${this.dataset.section}`).swiper ? document.querySelector(`.product-converter__gallery#gallery-${this.dataset.section}`).swiper && document.querySelector(`.product-converter__gallery#gallery-${this.dataset.section}`).swiper.slides.forEach((t => {
                                if (!t.classList.contains("swiper-slide-duplicate")) {
                                    const n = t.getAttribute("data-id"),
                                        i = t.getAttribute("data-swiper-slide-index");
                                    e == n && document.querySelector(`.product-converter__gallery#gallery-${this.dataset.section}`).swiper.slideToLoop(i)
                                }
                            })) : t.prepend(t.querySelector('[data-id="' + e + '"]')), document.querySelector(".sticky-add-to-cart__image") && (document.querySelector(".sticky-add-to-cart__image").src = this.currentVariant.featured_media.preview_image.src)
                        }
                    }
                    updateURL() {
                        this.currentVariant && "false" !== this.dataset.updateUrl && window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`)
                    }
                    updateVariantInput() {
                        document.querySelectorAll(`#form-product-${this.dataset.section}, #form-product-installment-${this.dataset.section}`).forEach((t => {
                            const e = t.querySelector('input[name="id"]');
                            e.value = this.currentVariant.id, e.dispatchEvent(new Event("change", {
                                bubbles: !0
                            }))
                        })), document.querySelector(".product-converter") && document.querySelectorAll("variant-selects").forEach((t => {
                            this.currentVariant.option1 && (t.querySelectorAll("select")[0].value = this.currentVariant.option1), this.currentVariant.option2 && (t.querySelectorAll("select")[1].value = this.currentVariant.option2), this.currentVariant.option3 && (t.querySelectorAll("select")[2].value = this.currentVariant.option3)
                        }))

      
                    }   
                    renderProductInfo() {
                        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection?this.dataset.originalSection:this.dataset.section}`).then((t => t.text())).then((t => {
                            const e = (new DOMParser).parseFromString(t, "text/html"),
                                n = document.getElementById(`price-${this.dataset.section}`),
                                i = e.getElementById(`price-${this.dataset.originalSection?this.dataset.originalSection:this.dataset.section}`),
                              nn = document.getElementsByClassName(`price-update`),
                             
                                r = document.getElementById(`sticky-price-${this.dataset.section}`),
                                s = e.getElementById(`sticky-price-${this.dataset.originalSection?this.dataset.originalSection:this.dataset.section}`),
                                c = document.getElementById(`pickup-availability-${this.dataset.section}`),
                                d = e.getElementById(`pickup-availability-${this.dataset.originalSection?this.dataset.originalSection:this.dataset.section}`),
                                l = document.getElementById(`pickup-availability-modal-${this.dataset.section}`),
                                u = e.getElementById(`pickup-availability-modal-${this.dataset.originalSection?this.dataset.originalSection:this.dataset.section}`);
                          
                         $(".price-update").html(" <span>&nbsp; - &nbsp;  </span>"+i.innerHTML);

                           
                            i && n ? (n.classList.remove("u-invisible"), n.innerHTML = i.innerHTML) : n.classList.add("u-invisible"), s && r ? (r.classList.remove("u-invisible"), r.innerHTML = s.innerHTML) : r && r.classList.add("u-invisible"), d && c && (c.innerHTML = d.innerHTML), u && l && (l.innerHTML = u.innerHTML);
                            const p = document.querySelector(".pickup-availability"),
                                h = document.getElementById("overlay"),
                                y = document.getElementById("pickup-availability-open"),
                                f = document.getElementById("pickup-availability-close");
                            y && document.getElementById("pickup-availability-open").addEventListener("click", (function() {
                                p.classList.add("open"), h.classList.add("open"), document.body.classList.add("active", "minicart"), (0, o.hO)(!0), a()
                            })), f && document.getElementById("pickup-availability-close").addEventListener("click", (function() {
                                p.classList.remove("open"), document.body.classList.remove("active", "minicart"), (0, o.hO)(!1), overlay.classList.remove("open", "overlay--all"), (0, o.zx)(p)
                            }))
                        }))
                       
                     

                     
                    }
                    toggleStockStatus(t) {
                        const e = document.querySelectorAll(`.form-product-${this.dataset.section}`),
                            n = document.getElementById(`stock-status-${this.dataset.section}`);
                        n && n.classList.remove("u-invisible"), e && (t ? (e.forEach((t => {
                            const e = t.querySelector('[name="add"]'),
                                n = t.querySelector('[name="add"] > span:not(.cart-icon)');
                            e && (e.removeAttribute("disabled"), n.textContent = "Add to cart")
                        })), n && n.classList.add("in-stock")) : (e.forEach((t => {
                            const e = t.querySelector('[name="add"]'),
                                n = t.querySelector('[name="add"] > span:not(.cart-icon)');
                            e && (e.setAttribute("disabled", "disabled"), n.textContent = "Sold out")
                        })), n && n.classList.remove("in-stock")))
                    }
                    setUnavailable() {
                      
                        const t = document.querySelectorAll(`.form-product-${this.dataset.section}`),
                            e = document.getElementById(`stock-status-${this.dataset.section}`);
                        t.forEach((t => {
                            const n = t.querySelector('[name="add"]'),
                                i = t.querySelector('[name="add"] > span:not(.cart-icon)');
                            n && (i.textContent = window.cartStrings.unavailable, n.setAttribute("disabled", "disabled"), e && e.classList.add("u-invisible"))
                        }));
                        const n = document.getElementById(`price-${this.dataset.section}`),
                            i = document.getElementById(`sticky-price-${this.dataset.section}`);
                        n && n.classList.add("u-invisible"), i && i.classList.add("u-invisible")
                    }
                    getVariantData() {
                        return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent), this.variantData
                    }
                }
                customElements.define("variant-selects", c)
            },
            4105: function(t, e, n) {
                n.d(e, {
                    hO: function() {
                        return i
                    },
                    zx: function() {
                        return o
                    }
                });
                const i = function() {
                    let t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                        e = window.innerWidth - document.body.offsetWidth;
                    const n = document.getElementById("nav-wrapper");
                    t ? (document.body.classList.add("no-scroll"), document.body.style.paddingRight = e + "px", n.style.paddingRight = e + "px") : (document.body.classList.remove("no-scroll"), document.body.style.paddingRight = "0px", n.style.paddingRight = "0px")
                };
                document.querySelectorAll(".local-scroll").forEach((t => {
                    t.addEventListener("click", (t => {
                        t.preventDefault(), t.stopPropagation();
                        const e = t.target.getAttribute("href");
                        (t => {
                            Math.easeInOutQuad = function(t, e, n, i) {
                                return (t /= i / 2) < 1 ? n / 2 * t * t + e : -n / 2 * (--t * (t - 2) - 1) + e
                            };
                            const e = document.getElementById("grid-archive-header"),
                                n = document.getElementById("nav-wrapper");
                            let i = 0;
                            e && (i = e.offsetHeight + 50), n && (navWrapperOffset = n.offsetHeight + 50);
                            const r = t.offsetTop - i - navWrapperOffset,
                                o = window.scrollY,
                                a = r - o;
                            let s = 0;
                            const c = () => {
                                s += 5;
                                const t = Math.easeInOutQuad(s, o, a, 200);
                                window.scrollTo(0, t), s < 200 && setTimeout(c, 5)
                            };
                            c()
                        })(document.querySelector(e))
                    }))
                }));
                const r = {};

                function o() {
                    let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                    document.removeEventListener("focusin", r.focusin), document.removeEventListener("focusout", r.focusout), document.removeEventListener("keydown", r.keydown), t && t.focus()
                }
            },
            4040: function() {}
        },
        n = {};

    function i(t) {
        var r = n[t];
        if (void 0 !== r) return r.exports;
        var o = n[t] = {
            exports: {}
        };
        return e[t].call(o.exports, o, o.exports, i), o.exports
    }
    i.m = e, t = [], i.O = function(e, n, r, o) {
            if (!n) {
                var a = 1 / 0;
                for (l = 0; l < t.length; l++) {
                    n = t[l][0], r = t[l][1], o = t[l][2];
                    for (var s = !0, c = 0; c < n.length; c++)(!1 & o || a >= o) && Object.keys(i.O).every((function(t) {
                        return i.O[t](n[c])
                    })) ? n.splice(c--, 1) : (s = !1, o < a && (a = o));
                    if (s) {
                        t.splice(l--, 1);
                        var d = r();
                        void 0 !== d && (e = d)
                    }
                }
                return e
            }
            o = o || 0;
            for (var l = t.length; l > 0 && t[l - 1][2] > o; l--) t[l] = t[l - 1];
            t[l] = [n, r, o]
        }, i.n = function(t) {
            var e = t && t.__esModule ? function() {
                return t.default
            } : function() {
                return t
            };
            return i.d(e, {
                a: e
            }), e
        }, i.d = function(t, e) {
            for (var n in e) i.o(e, n) && !i.o(t, n) && Object.defineProperty(t, n, {
                enumerable: !0,
                get: e[n]
            })
        }, i.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e)
        }, i.j = 6348,
        function() {
            var t = {
                6348: 0,
                3625: 0
            };
            i.O.j = function(e) {
                return 0 === t[e]
            };
            var e = function(e, n) {
                    var r, o, a = n[0],
                        s = n[1],
                        c = n[2],
                        d = 0;
                    if (a.some((function(e) {
                            return 0 !== t[e]
                        }))) {
                        for (r in s) i.o(s, r) && (i.m[r] = s[r]);
                        if (c) var l = c(i)
                    }
                    for (e && e(n); d < a.length; d++) o = a[d], i.o(t, o) && t[o] && t[o][0](), t[o] = 0;
                    return i.O(l)
                },
                n = self.webpackChunkworkflow = self.webpackChunkworkflow || [];
            n.forEach(e.bind(null, 0)), n.push = e.bind(null, n.push.bind(n))
        }(), i.O(void 0, [1216], (function() {
            return i(4528)
        }));
    var r = i.O(void 0, [1216], (function() {
        return i(4040)
    }));
    r = i.O(r)
}();

(function() {
   // your page initialization code here
   // the DOM will be available here
  
var xval=$("#Option-template--21556813234488__main-0-").val();
  console.log(xval);
  $(".x"+xval).addClass("active");


  
})();
$(".cvarsel").click(function(){
  $(".cvarsel").removeClass("active");
    $(this).addClass("active")
    
})



